"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switch = exports.SwitchBackground = void 0;
const native_1 = __importDefault(require("styled-components/native"));
exports.SwitchBackground = native_1.default.TouchableHighlight `
  display: flex;
  border-radius: 12px;
  background-color: ${({ theme, isEnabled }) => isEnabled ? theme.bpCore.colors.darkGrey : theme.bpCore.colors.lightGrey};
  width: 48px;
  height: 24px;
  position: relative;
`;
exports.Switch = native_1.default.View `
  border-radius: 10px;
  position: absolute;
  top: 2px;
  width: 20px;
  height: 20px;
  shadow-color: ${({ theme }) => theme.bpCore.colors.text};
  shadow-offset: 0 4px;
  shadow-radius: 6px;
  shadow-opacity: 0.1;
  elevation: 1;
  background-color: ${({ theme, isEnabled }) => 
// eslint-disable-next-line sonarjs/no-all-duplicated-branches
isEnabled ? theme.bpCore.colors.white : theme.bpCore.colors.white};
`;
